import { createContext, type Dispatch, type SetStateAction } from 'react';
import { type Nullable } from '@direct-frontend/stdlib';
import { type InventoryCompareProductsModalStep } from './lib/steps';
import {
    type OpenApiSchemaImportTypeSettings,
    type OpenApiSchemaIntegrationStatus,
    type OpenApiSchemaMapping,
} from '../../api/schema';
import { type SupportedIntegrationTypes, type TagWithScope } from '../../lib/integrations';

type ChangeSourceFunction = (params: {
    mapping: OpenApiSchemaMapping;
    createStrategy?: OpenApiSchemaImportTypeSettings['create_strategy'];
}) => void;

export type InventoryCompareProductsModalContextType = {
    isOpen: boolean;
    changeSource: ChangeSourceFunction;
    open: (source: SupportedIntegrationTypes, changeSource: ChangeSourceFunction) => void;
    close: () => void;
    source: SupportedIntegrationTypes | null;
    isLoading: {
        value: boolean;
        setValue: (value: boolean) => void;
    };
    step: InventoryCompareProductsModalStep;
    goToNextStep: () => void;
    goToPreviousStep: () => void;
    dryMapping: {
        status: OpenApiSchemaIntegrationStatus | undefined;
        setStatus: (status: OpenApiSchemaIntegrationStatus | undefined) => void;
    };
    isProcessingDryMapping: {
        value: boolean;
        setValue: (value: boolean) => void;
    };
    strategy: {
        value: OpenApiSchemaImportTypeSettings['create_strategy'];
        setValue: (value: OpenApiSchemaImportTypeSettings['create_strategy']) => void;
    };
    parameters: {
        value: TagWithScope[];
        setValue: Dispatch<SetStateAction<TagWithScope[]>>;
        isReadonly: boolean;
    };
    save: {
        isSaving: boolean;
        startSaving: () => void;
        stopSaving: () => void;
    };
};

export type InventoryCompareProductsModalContextTypeNullable = Nullable<InventoryCompareProductsModalContextType>;

export const InventoryCompareProductsModalContext =
    createContext<InventoryCompareProductsModalContextTypeNullable>(null);
